<template>

  <div>
    <Navbar />
    <div class="container">
      <div class="img">
        <img src="@/assets/images/pages/business_shop.svg">
      </div>
      <div class="signup-container">
        <div class="form">
          <Logo class="logo text-primary fill-current" />
          <h3>Store Details</h3>
          <p>Good! You can start expand your own business here.</p>
          <div class="input-div mt-2">
            <div>
              <vs-input
                v-validate="'required|max:255'"
                data-vv-validate-on="blur"
                name="store name"
                label-placeholder="STORE NAME"
                v-model="organization_name"
                class="w-full mt-6"
                icon-pack="feather"
                icon="icon-briefcase"
                icon-no-border
                size="large" />
                <span class="text-danger text-sm float-left">{{ errors.first('store name') }}</span>
            </div>
          </div>

          <div class="input-div mb-10">
            <div>
              <vx-input-group class="w-full mt-6">
                <vs-input
                v-validate="'required|alpha_num|min:5|max:255'"
                data-vv-validate-on="blur" 
                name="sub domain"
                v-model="subdomain" 
                size="large"
                placeholder="SUB DOMAIN"
                @keyup="checkSubdomain"/>

                <template slot="append">
                  <div class="append-text bg-primary">
                    <span>.quicksend.asia</span>
                  </div>
                </template>
              </vx-input-group>
              <span class="text-danger text-sm float-left" >{{ errors.first('sub domain') }}</span>
              <span v-if="!errors.first('sub domain')" :class="[dyna_class ? 'text-success text-sm' : 'text-danger text-sm']">{{ message }}</span>
            </div>
          </div>

          <div class="input-div mb-10">
            <div>
            <vx-tooltip text="This is an estimation of how many sales person can be invited">
            <vs-input-number
            v-validate="'required|numeric|max:3'"
            name="sales agent"
            v-model="sales_agent" 
            label="Sales/Agent Count:"
            class="w-full mt-6"
            size="large"/>
            </vx-tooltip>
            <span class="text-danger text-sm float-left" >{{ errors.first('sales agent') }}</span>
            </div>
          </div>
        
          <vs-button class="w-full mt-6" @click="activePrompt = true" :disabled="!validateForm">Continue</vs-button>
          <vs-prompt 
            title="About Subdomain" 
            @cancel="val=''"
            @accept="registerOwner(organization_name, subdomain, sales_agent)"
            @close="val=''"
            :active.sync="activePrompt">
              <div class="prompt-content">
                <p>Please do not register any trademark or famous trade name as subdomain without owner's consent e.g. starbucks.quicksend.asia, mcdonalds.quicksend.asia . If you do, we reserve the right to claim the subdomain back without compensation to you.</p>
              </div>
          </vs-prompt>
        </div>  
      </div>
    </div>
  </div>
</template>

<script>
import Logo from '@/layouts/components/Logo.vue'
import Navbar from '@/views/components/quicksend-navbar/Navbar.vue'
import axios from '@/axios'
import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      organization_name: '',
      sales_agent: 1,
      subdomain: '',
      dyna_class: true,
      message: '',
      isAvailable: false,
      activePrompt:false,
    }
  },

  components: {
    Logo,
    Navbar
  },

  created () {
    this.checkSubdomain = _.debounce(this.checkSubdomain, 1000, {
      leading: false,
      trailing: true,
    })
  },

  computed: {
    ...mapGetters('user', ['user']),
    validateForm () {
      return !this.errors.any() && this.organization_name !== '' && this.subdomain !== '' && this.isAvailable !== false && this.sales_agent > 0
    },
    email: {
      get() {
        return this.user.email
      }
    },
  },

  methods: {
    checkSubdomain () {
      const subdomain = this.subdomain
      if (subdomain.length >= 5) {
        axios.get(`/organization?subdomain=${subdomain}`)
          .then((res) => {
            if (res.status === 200) {
              this.dyna_class = false
              this.message = `Oh No! ${subdomain}.quicksend.asia is not available!`
              this.isAvailable = false
            } 
          })
          .catch((err) => {
            if(err.status === 404) {
              this.dyna_class = true
              this.message = `${subdomain}.quicksend.asia is available! Wohoo!`
              this.isAvailable = true
            }
          })
      }
    },

    async registerOwner (organization_name, subdomain, sales_agent) {
      if (_.isEmpty(this.user.first_name))  {
        let userDetails = JSON.parse(localStorage.getItem('user_details'));
        if (_.isEmpty(userDetails)) {
          this.$vs.notify({
            title: 'Error',
            text: 'Cannot find user details',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
          return; /// TODO: redirect to somewhere
        }

        this.$store.commit('user/UPDATE_USER_INFO', userDetails);
        localStorage.removeItem('user_details'); // clean up 
      }

      const payload = {
        first_name : this.user.first_name,
        last_name : this.user.last_name,
        phone_number: this.user.phone_number,
        gender: this.user.gender,
        dob: this.user.dob,
        name: organization_name,
        subdomain,
        sales_agent
      }

      await this.$store.dispatch('user/updateDetails', payload).then((result) => {
        this.$vs.notify({
          title: 'Success',
          text: 'You are one of the QuickSender!',
          iconPack: 'feather',
          icon: 'icon-check',
          color: 'success'
        })
        this.$vs.loading()
        setTimeout(() => {
          this.$vs.loading.close()
          let user = Object.assign({}, result.user_detail);
          delete user['user_id'];
          this.$store.commit('user/UPDATE_USER_INFO', user);
          this.$router.push({path: '/dashboard'});
        }, 1000);
      }).catch(() => {
        this.$vs.notify({
          title: 'Error',
          text: 'Internal API Error',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      });
    },
  }
}
</script>

<style>
* {
    margin: 0;
    box-sizing: border-box;
}

body {
  display:grid;
  width: 100%;
  height:100%
}

vs-input[v-model="email"]  {
    font-size: 1.75rem !important;
}

.vdp-datepicker input{
  height: 50px;
  text-align: center;
}

.container {
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: repeat(2,1fr);
    grid-template-areas: "image form";
    grid-gap: 10rem;
    padding: 0 2rem;
}

.img{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    grid-area: image;
}

.img img{
   width: 600px; 
}

.signup-container {
    display: flex;
    align-items: center;
    text-align: center;
    background-color: #fff;
    border-radius: 10px;
    padding: 15px 25px;
    position: relative;
    width: 100%;
    z-index: 10;
    margin-top: 30px;
    margin-bottom: 30px;
    grid-area: form;
}

.form{
    width:360px;
}

.logo {
    width: 150px;
    place-items: center;
}

.vs-input-number {
    height: 50px;
}

/* .input {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    border: none;
    outline: none;
    background: none;
    padding: 0.5rem 0.7rem;
    font-size: 1.2rem;
    color: #555555;
} */


a{
  display: block;
  text-align: right;
  text-decoration: none;
  color: #999999;
  font-size: 0.9rem;
  transition: 0.3s;
  cursor: pointer;
}

a:hover{
  color:#f9278e;
}

.label-placeholder {
    padding: 1rem !important;
    padding-left: .5rem !important;
    font-size: 0.7rem !important;
    font-weight: 400;
    color:rgba(0,0,0,.4);
}

@media screen and (max-width: 1050px) {
    .container{
        grid-gap: 5rem;
    }
}

@media screen and (max-width: 1000px) {
    .form{
        width: 290px;
    }

    .form h3{
        font-size: 1.2rem;
    }
    .img img{
        width: 400px;
    }
}

vs-input[label-placeholder]{
    text-transform:capitalize;
} 

vs-input[label-placeholder]:focus{
    float: left;
} 

@media screen and (max-width: 900px) {
    .img{
        display:none;
    }
    .container{
        display: inherit;
    }
    .signup-container{
        justify-content: center;
    }
}

#Coin {
  animation: coin 1.5s ease-in infinite alternate;
  transform-origin: center;
  transform-box: fill-box;
}

@keyframes coin{
  from{
    transform: rotateY(0deg) translateY(0);
  }
  to{
    transform: rotateY(360deg) translateY(-150px);
  }
}

#Door {
  animation: door 1.5s ease infinite alternate;
  transform-origin: left;
  transform-box: fill-box;
}

@keyframes door {
  from{
    transform: rotateY(0deg);
  }
  to{
    transform: rotateY(180deg);
  }
}

</style>
